import { getValue } from "@utils/lodash";
import "./index.scss";
import { saveAs } from "file-saver";
import { downloadURL } from "@services/auth.service";
import { getEncodedKey } from "@_common/text-helpers";
import { handleDownloadOnClick } from "@_common/downloadfile";

export default function DataImported(props: any) {
  const handleDownload = async (url: string) => {
    if (url) {
      // var link = document.createElement("a");
      // link.target = "_blank";
      // link.download = "Contact";
      // link.href = url;
      // link.click();
      // let resp = await downloadURL(getEncodedKey(url));
      // if (resp) {
      //   saveAs(getValue(resp, `data.url`, ""), "Contact");
      // }
      handleDownloadOnClick(url,'Contact')
    }
  };
  return (
    <>
      <div className="popup-wrapper__details text-center">
        <div className="popup-wrapper__close-btn">
          <img
            src="/images/close-black.svg"
            className="img-fluid cursor-pointer"
            onClick={() => {
              props.closePopup();
            }}
          />
        </div>
        <h6 className="popup-wrapper__data-imported">Data Imported</h6>
        <img src="/images/popup/transfer-files.svg" className="img-fluid" />
        <h5 className="popup-wrapper__records">
          {getValue(props, `response.counts.totalRecords`, 0)} Records Found
        </h5>
        <p>
          {getValue(props, `response.counts.failedRecords`, 0)} Records Import
          Failed -{" "}
          <a
            onClick={() =>
              handleDownload(getValue(props, `response.downloadUrl`, ""))
            }
            style={{ color: "blue", cursor: "pointer" }}
          >
            Click here to download
          </a>
        </p>
      </div>
    </>
  );
}
